import BContainer, { BEV_FLOOR_ADDED, kAbortEnum, register_b_class } from "./BBase";
import BFloor, { kPresetFloorColorList } from "./BFloor";

class BBuilding extends BContainer {
	constructor(flags, forceSetId) {
		super(flags, forceSetId);
		this.isBuilding = true;

		this.nextFloorMap = new WeakMap();

		this.title = "Unnamed building";
		this.useStandardDisplayItemAsRepresentative();

		this.lastFloorColorIndex = -1;
	}

	addItem(item, beforeThisId) {
		super.addItem(item, beforeThisId);
		this.updateFloorOrder();
		this.updateNextFloorMap();

		if (item instanceof BFloor) {
			this.fireEvent(this, BEV_FLOOR_ADDED, item);
		}
	}

	afterItemRemove() {
		this.updateFloorOrder();
		this.updateNextFloorMap();
	}

	updateFloorOrder() {
		const ls = [];
		this.forEachFloor( f => ls.push(f) );
		ls.sort( (a,b) => { return a.floorAltitude - b.floorAltitude } );
		for (let i = 0;i < ls.length;++i) {
			ls[i].stackOrder = i;
		}
	}

	forEachFloor(fn) {
		this.forEach(ch => {
			if (ch instanceof BFloor) {
				return fn(ch);
			}
		})
	}

	getFloorBefore(thisFloor) {
		let lastFloor = null;
		this.forEachFloor( f => {
			if (f === thisFloor) { return kAbortEnum; }

			lastFloor = f;
		} );

		return lastFloor;
	}

	countFloors() {
		let i = 0;
		this.forEachFloor( () => { ++i; } );

		return i;
	}

	getLastFloor() {
		let last_f = null;
		this.forEachFloor( f => { last_f = f; } );

		return last_f;
	}

	generateDisplayList(outList) {
		this.connectTransformTree(outList);
	}

	generateNextFloorColorIndex() {
		this.lastFloorColorIndex = (this.lastFloorColorIndex + 1) % kPresetFloorColorList.length;

		return this.lastFloorColorIndex;
	}

	updateNextFloorMap() {
		let prev = null;
		this.forEachFloor( f => {
			if (prev) {
				this.nextFloorMap.set(prev, f);
			}

			prev = f;
		} );
	}

	getNextFloorOf(f) {
		return this.nextFloorMap.get(f) ?? null;
	}

	serialize() {
		const o = super.serialize();
		o.title = this.title;
		o.lastFloorColorIndex = this.lastFloorColorIndex;

		return o;
	}

	deserialize(o) {
		this.title = o.title;
		this.lastFloorColorIndex = o.lastFloorColorIndex;
	}
}

register_b_class(BBuilding);
export default BBuilding;